import { render, staticRenderFns } from "./setStaticInfoDialog.vue?vue&type=template&id=0f9812e7&scoped=true"
import script from "./setStaticInfoDialog.vue?vue&type=script&lang=js"
export * from "./setStaticInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./setStaticInfoDialog.vue?vue&type=style&index=0&id=0f9812e7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9812e7",
  null
  
)

export default component.exports